import axios from 'axios';

export default {
  get: () => axios.get('/api/v1/avg/year'),
  create: (params) => axios.post('/api/v1/avg/year', params),
  remove: (params) => axios.delete('/api/v1/avg/year', { params })
};
